import { fetchFormDataFromLegacy } from '@/api/legacyAPI';
import { LocalStorageService } from '@/core/services/localStorageService';

export const FormDataService = () => {
    const get = (category) => {
        return LocalStorageService.get(`${category}FormValues`)
    }

    const getLegacyData = async (fid) => {
        return await fetchFormDataFromLegacy(fid)
    }

    const set = (category, input) => {
        const existing = get(category) ?? {};
        LocalStorageService.set(`${category}FormValues`, {
            ...input,
            email: input?.email !== undefined ? input.email : (existing.email ?? ''),
            newsletter_optin: input?.newsletter_optin !== undefined
                ? input.newsletter_optin
                : (existing.newsletter_optin ?? false),
        });
    }

    const updateEmailValue = (category, value) => {
        LocalStorageService.update(`${category}FormValues`, 'email', value);
    }

    const updateNewsletterOptin = (category, value) => {
        LocalStorageService.update(`${category}FormValues`, 'newsletter_optin', value);
    }

    const updateVehicleValue = (category, value) => {
        LocalStorageService.update(`${category}FormValues`, 'vehicle.value', value);
    }

    const updateVehicleMinRecommendedValue = (category, value) => {
        LocalStorageService.update(`${category}FormValues`, 'vehicle.minRecommendedValue', value);
    }

    const updateVehicleMaxRecommendedValue = (category, value) => {
        LocalStorageService.update(`${category}FormValues`, 'vehicle.maxRecommendedValue', value);
    }

    const updateDuration = (category, value) => {
        LocalStorageService.update(`${category}FormValues`, 'duration', value);
    }

    const updatePacket = (category, value) => {
        LocalStorageService.update(`${category}FormValues`, 'packet', value);
    }

    const updateVehicle = (category, response) => {
        let mappedVehicle = {
            usedVehicle: response.formData.vehicle.is_vehicle_used,
            secondDriver: !response.formData.customer.only_driver || response.formData.customer.secondDriver === true,
            birthDate2: response.formData.customer.driver_data[1]?.date_of_birth ? (() => {
              const date = new Date(response.formData.customer.driver_data[1].date_of_birth);
              return {
                day: String(date.getDate()).padStart(2, '0'),
                month: String(date.getMonth() + 1).padStart(2, '0'),
                year: date.getFullYear().toString()
              };
            })() : {},
            licenseYears2: response.formData.customer.driver_data[1]?.license_years,
            duration: response.formData.contract.duration,
            packet: response.formData.contract.packet_category,
            vehicleType: response.formData.vehicle.vehicle_type,
            customerType: response.formData.customer.customer_type,
            job: response.formData.customer.occupation_type,
            has_high_turnover: response.formData.customer.has_high_turnover,
            birthDate: response.formData.customer.driver_data[0]?.date_of_birth ? (() => {
              const date = new Date(response.formData.customer.driver_data[0].date_of_birth);
              return {
                day: String(date.getDate()).padStart(2, '0'),
                month: String(date.getMonth() + 1).padStart(2, '0'),
                year: date.getFullYear().toString()
              };
            })() : {},
            vehicle: {
              value: response.formData.vehicle.value,
              manufacturer: response.formData.vehicle.manufacturer_text,
              manufacturerId: response.formData.vehicle.manufacturer_id,
              model: response.formData.vehicle.vehicle_model_edition_id,
              manufactureYear: parseInt(new Date(response.formData.vehicle.manufacturing_date).getFullYear()),
              modelId: response.formData.vehicle.model_id,
              manufactureMonth: (new Date(response.formData.vehicle.manufacturing_date).getMonth()+1).toString().padStart(2, '0'),
              edition: response.formData.vehicle.vehicle_model_text,
              editionId: response.formData.vehicle.vehicle_model_edition,
              taxableHP: response.formData.vehicle.taxable_hp.toString(),
              extraEdition: response.formData.vehicle.vehicleModelExtraEditionText,
              hasAlarm: response.formData.vehicle.hasAlarm,
              isHeavy: response.formData.vehicle.isHeavy,
              hasFridge: response.formData.vehicle.hasFridge,
              minRecommendedValue: response.viewData?.minRecommendedValue,
              maxRecommendedValue: response.viewData?.maxRecommendedValue,
              vehicleModelEditionId: response.formData.vehicle.vehicle_model_edition_id,
              vehicleModelText: response.formData.vehicle.vehicle_model_text,
              vehicleModelEdition: response.formData.vehicle.vehicle_model_edition,
              vehicleModelExtraEditionText: response.formData.vehicle.vehicleModelExtraEditionText,
              combinedHorsepower: response.formData.vehicle.combinedHorsepower,
              kw: response.formData.vehicle.kw,
              seats: response.formData.vehicle.seats,
              cc: response.formData.vehicle.cc,
              emissions: response.formData.vehicle.emissions,
              acceleration: response.formData.vehicle.acceleration,
              roofType: response.formData.vehicle.roofType,
              fuel: response.formData.vehicle.fuel,
            },
            licensePlate: response.formData.vehicle.license_plate,
            licenseYears: response.formData.customer.driver_data[0]?.license_years,
            postalCode: response.formData.customer.postal_code,
            email: response.formData.customer.driver_data[0]?.email ?? '',
        }

        if (response.formData.vehicle.vehicle_transfer_date) {
            mappedVehicle.transferDate = (() => {
                const date = new Date(response.formData.vehicle.vehicle_transfer_date);
                    return {
                        month: String(date.getMonth() + 1).padStart(2, '0'),
                        year: String(date.getFullYear()).padStart(4, '0')
                    };
            })()
        }

        set(category, mappedVehicle)
    }

    const updateLicensePlate = (category, licensePlate) => {
        LocalStorageService.update(`${category}FormValues`, 'licensePlate', licensePlate)
    }

    return {
        get,
        set,
        updatePacket,
        updateVehicle,
        getLegacyData,
        updateDuration,
        updateEmailValue,
        updateLicensePlate,
        updateVehicleValue,
        updateNewsletterOptin,
        updateVehicleMinRecommendedValue,
        updateVehicleMaxRecommendedValue,
    }
}
